export default {
	about: {
		title: true,
	},
	main: {
		tagline: true,
	},
	services: {
		title: true,
	},
	accolades: {
		title: true,
	},
	widgets: {
		title: true,
	},
	testimonials: {
		title: true,
		navButtonColor: '#000000',
	},
	contact: {
		title: true,
	},
};
